(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  /* Homepage intro splash — once per session/tab, max ~4s */
  (function initIntroSplash() {
    const KEY = 'ld-intro-seen';
    const root = qs('[data-intro-splash]');
    if (!root || root.hidden) return;

    const reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const holdMs = reduce ? 1400 : 3400;
    const fadeMs = reduce ? 280 : 550;
    const hardCap = 4000;
    let done = false;

    function finish() {
      if (done) return;
      done = true;
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (e) {}
      root.classList.add('is-leaving');
      window.setTimeout(() => {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        root.remove();
        document.documentElement.classList.remove('intro-active');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }, fadeMs);
    }

    window.setTimeout(finish, Math.min(holdMs, hardCap - fadeMs));
    window.setTimeout(finish, hardCap);
  })();

  /* Quick-add on product cards → /cart/add.js (no cart drawer) */
  function updateCartCount(count) {
    const badge = qs('[data-cart-count]');
    if (!badge) return;
    const n = Number(count) || 0;
    badge.textContent = String(n);
    if (n > 0) badge.removeAttribute('hidden');
    else badge.setAttribute('hidden', '');
  }

  function setQuickAddState(btn, state) {
    const labelEl = qs('.product-card__quick-add-label', btn);
    const labelAdd = btn.getAttribute('data-label-add') || '';
    const labelAdded = btn.getAttribute('data-label-added') || labelAdd;
    btn.classList.remove('is-loading', 'is-added');
    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.disabled = true;
    } else if (state === 'added') {
      btn.classList.add('is-added');
      btn.disabled = false;
      if (labelEl && labelAdded) labelEl.textContent = labelAdded;
      window.setTimeout(() => {
        btn.classList.remove('is-added');
        if (labelEl && labelAdd) labelEl.textContent = labelAdd;
      }, 1600);
    } else {
      btn.disabled = false;
      if (labelEl && labelAdd) labelEl.textContent = labelAdd;
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    setQuickAddState(btn, 'loading');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      credentials: 'same-origin',
    })
      .then((res) => {
        if (!res.ok) throw new Error('add_failed');
        return res.json();
      })
      .then(() => fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }))
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count !== 'undefined') updateCartCount(cart.item_count);
        setQuickAddState(btn, 'added');
      })
      .catch(() => {
        setQuickAddState(btn, 'idle');
        window.location.href = '/cart';
      });
  });

  /* Related products carousel */
  qsa('[data-related-carousel]').forEach((section) => {
    const track = qs('[data-related-track]', section);
    const prev = qs('[data-related-prev]', section);
    const next = qs('[data-related-next]', section);
    if (!track) return;
    const step = () => Math.max(240, Math.floor(track.clientWidth * 0.85));
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* Homepage featured product carousels — auto-scroll LEFT */
  qsa('[data-product-carousel]').forEach((section) => {
    const track = qs('[data-product-carousel-track]', section);
    const prev = qs('[data-product-carousel-prev]', section);
    const next = qs('[data-product-carousel-next]', section);
    if (!track) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const wantAuto = section.getAttribute('data-autoplay') === 'true';
    const loopable = wantAuto && !reduceMotion;
    const interval = Math.max(2000, parseInt(section.getAttribute('data-interval'), 10) || 4000);
    let timer = 0;
    let paused = false;
    let wrapping = false;

    const originals = qsa('[data-product-carousel-slide]', track);
    if (originals.length === 0) return;

    /* Duplicate slides so leftward scroll wraps without a jump */
    if (loopable && originals.length >= 2) {
      const frag = document.createDocumentFragment();
      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        frag.appendChild(clone);
      });
      track.appendChild(frag);
    }

    const slideStep = () => {
      const slide = qs('[data-product-carousel-slide]', track);
      if (!slide) return Math.max(240, Math.floor(track.clientWidth * 0.85));
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 12;
      return Math.round(slide.getBoundingClientRect().width + gap);
    };

    const loopWidth = () => {
      if (!(loopable && originals.length >= 2)) return 0;
      return Math.round(track.scrollWidth / 2);
    };

    const normalize = () => {
      if (!loopable || originals.length < 2 || wrapping) return;
      const half = loopWidth();
      if (half <= 0) return;
      if (track.scrollLeft >= half) {
        wrapping = true;
        track.scrollLeft = track.scrollLeft - half;
        wrapping = false;
      } else if (track.scrollLeft < 0) {
        wrapping = true;
        track.scrollLeft = track.scrollLeft + half;
        wrapping = false;
      }
    };

    /* scrollLeft += → content moves LEFT */
    const goLeft = (smooth) => {
      track.scrollBy({ left: slideStep(), behavior: smooth ? 'smooth' : 'auto' });
      if (!smooth) normalize();
    };

    const goRight = (smooth) => {
      if (loopable && originals.length >= 2 && track.scrollLeft <= 2) {
        wrapping = true;
        track.scrollLeft = track.scrollLeft + loopWidth();
        wrapping = false;
      }
      track.scrollBy({ left: -slideStep(), behavior: smooth ? 'smooth' : 'auto' });
    };

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    }

    function start() {
      stop();
      if (!loopable || paused) return;
      timer = window.setInterval(() => goLeft(true), interval);
    }

    function pause() {
      paused = true;
      section.classList.add('is-paused');
      stop();
    }

    function resume() {
      paused = false;
      section.classList.remove('is-paused');
      start();
    }

    if (prev) {
      prev.addEventListener('click', () => {
        goRight(true);
        if (loopable) start();
      });
    }
    if (next) {
      next.addEventListener('click', () => {
        goLeft(true);
        if (loopable) start();
      });
    }

    section.addEventListener('pointerenter', pause);
    section.addEventListener('pointerleave', resume);
    section.addEventListener('focusin', pause);
    section.addEventListener('focusout', (e) => {
      if (!section.contains(e.relatedTarget)) resume();
    });

    track.addEventListener('scroll', normalize, { passive: true });
    start();
  });

  /* Gender reveal — cursor-driven soft split (desktop) */
  qsa('[data-gender-reveal]').forEach((root) => {
    const stage = qs('[data-gender-stage]', root);
    if (!stage) return;
    let split = 50;
    let target = 50;
    let raf = 0;
    const desktop = () => window.matchMedia('(min-width: 750px)').matches;

    function apply() {
      root.style.setProperty('--split', split.toFixed(2) + '%');
    }

    function tick() {
      /* Slower trail: ~0.045/frame ≈ 250–300ms half-life at 60fps (was 0.12) */
      split += (target - split) * 0.045;
      if (Math.abs(target - split) < 0.03) split = target;
      apply();
      if (Math.abs(target - split) >= 0.03) raf = requestAnimationFrame(tick);
      else raf = 0;
    }

    function ask(next) {
      target = Math.min(78, Math.max(22, next));
      if (!raf) raf = requestAnimationFrame(tick);
    }

    stage.addEventListener('pointermove', (e) => {
      if (!desktop()) return;
      const r = stage.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      ask(x);
    });
    stage.addEventListener('pointerleave', () => {
      if (!desktop()) return;
      ask(50);
    });
    apply();
  });

  /* Hero scroll cue */
  qsa('[data-hero-scroll]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const href = el.getAttribute('href') || '';
      const id = href.startsWith('#') ? href.slice(1) : '';
      const target = id ? document.getElementById(id) : null;
      const hero = el.closest('.hero') || el.closest('.shopify-section');
      const next =
        target ||
        (hero && hero.parentElement
          ? hero.parentElement.nextElementSibling || hero.nextElementSibling
          : null);
      if (!next) return;
      e.preventDefault();
      const top = next.getBoundingClientRect().top + window.scrollY - 8;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  /* Homepage desktop: mark header section so sticky can bind to the wrapper */
  (function markHeaderSection() {
    const header = qs('[data-header]') || qs('.site-header');
    if (!header) return;
    const section = header.closest('.shopify-section');
    if (section) section.classList.add('site-header-section');
  })();

  /* Brand marquee — measure one group width so -shift matches the seam exactly.
     Old bug: CSS translateX(-50%) + per-group padding-inline made the loop
     jump mid-strip when group widths / padding weren’t a perfect half. */
  (function initBrandMarquee() {
    const roots = qsa('[data-brand-marquee-root]');
    if (!roots.length) return;

    function measure(root) {
      const track = qs('[data-brand-marquee-track]', root);
      const group = qs('[data-brand-marquee-group]', root);
      if (!track || !group) return;
      const imgs = qsa('img', group);
      const ready = imgs.every((img) => img.complete && img.naturalWidth > 0);
      const w = group.getBoundingClientRect().width;
      if (!w) return;
      const next = w.toFixed(2) + 'px';
      const prev = root.style.getPropertyValue('--marquee-shift');
      if (prev === next) return ready;
      root.style.setProperty('--marquee-shift', next);
      track.style.animation = 'none';
      // force reflow then restart so the new shift applies cleanly
      void track.offsetWidth;
      track.style.animation = '';
      return ready;
    }

    roots.forEach((root) => {
      const run = () => measure(root);
      run();
      qsa('img', root).forEach((img) => {
        if (!img.complete) img.addEventListener('load', run, { once: true });
      });
      window.addEventListener('resize', run, { passive: true });
      // after fonts/layout settle
      window.setTimeout(run, 120);
      window.setTimeout(run, 600);
    });
  })();

  /* #F*CK BASIC / #FUCK BASIC typewriter — fixed #, loop phrases */
  (function initCategoryTypewriter() {
    const root = qs('[data-typewriter]');
    const textEl = qs('[data-typewriter-text]', root);
    if (!root || !textEl) return;

    let phrases = ['FUCK BASIC', 'AND WEIRD <3'];
    try {
      const raw = root.getAttribute('data-typewriter-phrases');
      if (raw) phrases = JSON.parse(raw);
    } catch (e) {}

    const reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      textEl.textContent = phrases[0] || 'FUCK BASIC';
      root.setAttribute('aria-label', '#' + (phrases[0] || 'FUCK BASIC'));
      const cursor = qs('[data-typewriter-cursor]', root);
      if (cursor) cursor.hidden = true;
      return;
    }

    const typeMs = 75;
    const deleteMs = 45;
    const holdFullMs = 1600;
    const holdEmptyMs = 420;
    let phraseIndex = 0;
    let charIndex = 0;
    let deleting = false;

    function tick() {
      const phrase = phrases[phraseIndex] || '';
      if (!deleting) {
        charIndex = Math.min(charIndex + 1, phrase.length);
        textEl.textContent = phrase.slice(0, charIndex);
        root.setAttribute('aria-label', '#' + textEl.textContent);
        if (charIndex === phrase.length) {
          deleting = true;
          window.setTimeout(tick, holdFullMs);
          return;
        }
        window.setTimeout(tick, typeMs);
        return;
      }

      charIndex = Math.max(charIndex - 1, 0);
      textEl.textContent = phrase.slice(0, charIndex);
      root.setAttribute('aria-label', '#' + textEl.textContent);
      if (charIndex === 0) {
        deleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        window.setTimeout(tick, holdEmptyMs);
        return;
      }
      window.setTimeout(tick, deleteMs);
    }

    // Start empty after # so first type-in is visible
    textEl.textContent = '';
    charIndex = 0;
    window.setTimeout(tick, 500);
  })();

  /* MENU dropdown */
  const menuDrawer = qs('[data-menu-drawer]');
  const menuOpeners = qsa('[data-menu-open]');
  const menuClosers = qsa('[data-menu-close]');

  function openMenu() {
    if (!menuDrawer) return;
    const header = qs('[data-header]');
    if (header) {
      document.documentElement.style.setProperty(
        '--menu-offset',
        Math.round(header.getBoundingClientRect().bottom) + 'px'
      );
    }
    menuDrawer.classList.add('is-open');
    menuDrawer.setAttribute('aria-hidden', 'false');
    menuOpeners.forEach((el) => el.setAttribute('aria-expanded', 'true'));
    lockScroll(true);
  }

  function closeMenu() {
    if (!menuDrawer) return;
    menuDrawer.classList.remove('is-open');
    menuDrawer.setAttribute('aria-hidden', 'true');
    menuOpeners.forEach((el) => el.setAttribute('aria-expanded', 'false'));
    lockScroll(false);
  }

  menuOpeners.forEach((el) =>
    el.addEventListener('click', () => {
      if (menuDrawer && menuDrawer.classList.contains('is-open')) closeMenu();
      else openMenu();
    })
  );
  menuClosers.forEach((el) => el.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });

  /* Filters drawer */
  const filters = qs('[data-filters-drawer]');
  qsa('[data-filters-open]').forEach((el) =>
    el.addEventListener('click', () => {
      if (!filters) return;
      filters.classList.add('is-open');
      filters.setAttribute('aria-hidden', 'false');
      if (window.matchMedia('(max-width: 989px)').matches) lockScroll(true);
    })
  );
  qsa('[data-filters-close]').forEach((el) =>
    el.addEventListener('click', () => {
      if (!filters) return;
      filters.classList.remove('is-open');
      filters.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    })
  );

  /* Product gallery thumbs */
  qsa('[data-gallery]').forEach((gallery) => {
    const main = qs('[data-gallery-main]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-full');
        if (main && src) {
          main.src = src;
          qsa('[data-gallery-thumb]', gallery).forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });
  });

  /* Image carousel */
  qsa('[data-carousel]').forEach((carousel) => {
    const track = qs('[data-carousel-track]', carousel);
    const slides = qsa('[data-carousel-slide]', carousel);
    const dots = qsa('[data-carousel-dot]', carousel);
    if (!track || slides.length < 2) return;

    let index = 0;
    let timer = null;
    let startX = 0;
    let deltaX = 0;
    const autoplay = carousel.getAttribute('data-autoplay') === 'true';
    const interval = (parseInt(carousel.getAttribute('data-interval'), 10) || 5) * 1000;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      slides.forEach((s, n) => s.setAttribute('aria-hidden', n === index ? 'false' : 'true'));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    }

    function next() {
      goTo(index + 1);
    }
    function prev() {
      goTo(index - 1);
    }

    function startAuto() {
      stopAuto();
      if (!autoplay) return;
      timer = window.setInterval(next, interval);
    }
    function stopAuto() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    qsa('[data-carousel-next]', carousel).forEach((btn) =>
      btn.addEventListener('click', () => {
        next();
        startAuto();
      })
    );
    qsa('[data-carousel-prev]', carousel).forEach((btn) =>
      btn.addEventListener('click', () => {
        prev();
        startAuto();
      })
    );
    dots.forEach((dot) =>
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.getAttribute('data-index'), 10) || 0);
        startAuto();
      })
    );

    const wrap = qs('[data-carousel-track-wrap]', carousel) || track;
    wrap.addEventListener(
      'touchstart',
      (e) => {
        stopAuto();
        startX = e.touches[0].clientX;
        deltaX = 0;
      },
      { passive: true }
    );
    wrap.addEventListener(
      'touchmove',
      (e) => {
        deltaX = e.touches[0].clientX - startX;
      },
      { passive: true }
    );
    wrap.addEventListener('touchend', () => {
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) next();
        else prev();
      }
      startAuto();
    });

    goTo(0);
    startAuto();
  });

  /* Product page — multi-option variants, SKU/price, buy now */
  qsa('[data-product-section]').forEach((section) => {
    const form = qs('[data-product-form]', section) || qs('form.product-form', section);
    const select = form ? qs('[data-variant-select]', form) : null;
    const jsonEl = qs('[data-product-json]', section);
    let variants = [];
    try {
      variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    const skuWrap = qs('[data-product-sku-wrap]', section);
    const skuEl = qs('[data-product-sku]', section);
    const compareEl = qs('[data-compare-price]', section);
    const finalEl = qs('[data-final-price]', section);
    const addBtn = qs('[data-add-to-cart]', section);
    const buyBtn = qs('[data-buy-now]', section);
    const returnTo = form ? qs('[data-return-to]', form) : null;
    const moneyFormat =
      (window.Shopify && window.Shopify.money_format) ||
      '{{amount}} €';

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      const n = (Number(cents) / 100).toFixed(2).replace('.', ',');
      return n + ' €';
    }

    function selectedOptions() {
      const opts = [];
      qsa('[data-variant-picker]', section).forEach((picker) => {
        const idx = Number(picker.getAttribute('data-option-index') || 0);
        const sel = qs('.variant-option.is-selected', picker);
        opts[idx] = sel ? sel.getAttribute('data-option-value') : null;
      });
      return opts;
    }

    function findVariant() {
      const opts = selectedOptions();
      return (
        variants.find((v) => {
          return opts.every((val, i) => !val || v['option' + (i + 1)] === val);
        }) || null
      );
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (select) {
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (skuEl && skuWrap) {
        if (variant.sku) {
          skuEl.textContent = variant.sku;
          skuWrap.hidden = false;
        } else {
          skuEl.textContent = '';
          skuWrap.hidden = true;
        }
      }
      if (finalEl) finalEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      const available = !!variant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        if (available) addBtn.textContent = addBtn.getAttribute('data-label-add') || addBtn.textContent;
      }
      if (buyBtn) buyBtn.disabled = !available;
    }

    qsa('[data-variant-picker]', section).forEach((picker) => {
      qsa('[data-variant-option]', picker).forEach((btn) => {
        btn.addEventListener('click', () => {
          qsa('[data-variant-option]', picker).forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          applyVariant(findVariant());
        });
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', () => {
        if (returnTo) returnTo.value = '';
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', () => {
        if (returnTo) returnTo.value = '/checkout';
      });
    }

    // Color swatch fills from option text (common Greek/English names)
    const colorMap = {
      black: '#111',
      μαυρο: '#111',
      'μαύρο': '#111',
      white: '#f5f5f5',
      λευκο: '#f5f5f5',
      'λευκό': '#f5f5f5',
      red: '#c0392b',
      κοκκινο: '#c0392b',
      'κόκκινο': '#c0392b',
      blue: '#2c4a7a',
      μπλε: '#2c4a7a',
      green: '#2d6a4f',
      πρασινο: '#2d6a4f',
      'πράσινο': '#2d6a4f',
      beige: '#d6c3a8',
      μπεζ: '#d6c3a8',
      grey: '#8a8a8a',
      gray: '#8a8a8a',
      γκρι: '#8a8a8a',
      brown: '#6b4423',
      καφε: '#6b4423',
      'καφέ': '#6b4423',
      pink: '#e8a0bf',
      ροζ: '#e8a0bf',
      navy: '#1b2a4a',
    };
    qsa('.variant-option--color', section).forEach((btn) => {
      const val = (btn.getAttribute('data-option-value') || '').toLowerCase().trim();
      const sw = qs('.variant-option__swatch', btn);
      if (sw && colorMap[val]) sw.style.background = colorMap[val];
    });

    /* Social proof — «X πελάτες το παρακολουθούν τώρα» */
    const proof = qs('[data-social-proof]', section);
    const proofCount = proof ? qs('[data-social-proof-count]', proof) : null;
    if (proof && proofCount) {
      const MIN = 8;
      const MAX = 45;
      const pid = proof.getAttribute('data-product-id') || 'p';
      const key = 'ld-social-proof-' + pid;
      let n = MIN;
      try {
        const saved = sessionStorage.getItem(key);
        if (saved) {
          const parsed = parseInt(saved, 10);
          if (!Number.isNaN(parsed) && parsed >= MIN && parsed <= MAX) n = parsed;
        } else {
          n = MIN + Math.floor(Math.random() * (MAX - MIN + 1));
        }
      } catch (e) {
        n = MIN + Math.floor(Math.random() * (MAX - MIN + 1));
      }
      proofCount.textContent = String(n);

      function persist(val) {
        try {
          sessionStorage.setItem(key, String(val));
        } catch (e) {}
      }
      persist(n);

      function tickProof() {
        const step = 1 + Math.floor(Math.random() * 3); // 1–3
        const dir = Math.random() < 0.5 ? -1 : 1;
        let next = n + dir * step;
        if (next < MIN) next = MIN + Math.floor(Math.random() * 3);
        if (next > MAX) next = MAX - Math.floor(Math.random() * 3);
        if (next === n) next = Math.min(MAX, n + 1);
        proof.classList.add('is-updating');
        window.setTimeout(() => {
          n = next;
          proofCount.textContent = String(n);
          persist(n);
          proof.classList.remove('is-updating');
        }, 280);
        const delay = (60 + Math.floor(Math.random() * 60)) * 1000; // 1–2 min
        window.setTimeout(tickProof, delay);
      }
      window.setTimeout(tickProof, (60 + Math.floor(Math.random() * 60)) * 1000);
    }
  });
})();
